var map = {
	"./armorer.png": 37690,
	"./butcher.png": 66164,
	"./cartographer.png": 13324,
	"./cleric.png": 59296,
	"./desert.png": 47482,
	"./desertzombie.png": 1493,
	"./farmer.png": 4913,
	"./fisherman.png": 86985,
	"./fletcher.png": 98731,
	"./jungle.png": 90128,
	"./junglezombie.png": 71272,
	"./leatherworker.png": 51138,
	"./librarian.png": 63400,
	"./mason.png": 67998,
	"./nitwit.png": 72067,
	"./plains.png": 4867,
	"./plainszombie.png": 8531,
	"./savanna.png": 77029,
	"./savannazombie.png": 46054,
	"./shepherd.png": 11986,
	"./snow.png": 50021,
	"./snowzombie.png": 42682,
	"./swamp.png": 20581,
	"./swampzombie.png": 79422,
	"./taiga.png": 17603,
	"./taigazombie.png": 66802,
	"./toolsmith.png": 74668,
	"./weaponsmith.png": 8469,
	"./zombiearmorer.png": 74367,
	"./zombiebutcher.png": 50842,
	"./zombiecartographer.png": 43446,
	"./zombiecleric.png": 92507,
	"./zombiefarmer.png": 2513,
	"./zombiefisherman.png": 74960,
	"./zombiefletcher.png": 69831,
	"./zombieleatherworker.png": 53462,
	"./zombielibrarian.png": 23405,
	"./zombiemason.png": 7716,
	"./zombienitwit.png": 99199,
	"./zombieshepherd.png": 78083,
	"./zombietoolsmith.png": 46257,
	"./zombieweaponsmith.png": 35868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44266;